import axios from 'axios';
import { Message } from 'element-ui';
import router from '../router';
// import store from '@/store';
import { host } from '@/global-config';


axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';


// const loginInfo = window.localStorage.getItem('LOGIN_INFO') ? JSON.parse(window.localStorage.getItem('LOGIN_INFO')) : {};
// create an axios instance
const service = axios.create({
  baseURL: host, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
});
// request interceptor
service.interceptors.request.use(
  (config) => {
    const loginInfo = window.localStorage.getItem('LOGIN_INFO') ? JSON.parse(window.localStorage.getItem('LOGIN_INFO')) : {};
    config.headers.common.userName = loginInfo.userName;
    config.headers.sessionId = loginInfo.sessionId;
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  },
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    // if the custom code is not 20000, it is judged as an error.
    if (response.data.error_code !== 0) {
      Message({
        message: response.data.error_msg || 'Error',
        type: 'error',
      });
      // 登录失效
      if (response.data.error_code === -1005) {
        router.push({ path: '/login' });
      }
    }
    return response;
  },
  (error) => {
    console.log('err', error); // for debug
    Message({
      message: error.message,
      type: 'error',
    });
    return Promise.reject(error);
  },
);

export default service;
